import { useEffect } from 'react';
import { globalShortcutsService } from '../services/globalShortcutsService';
import { createFileLogger } from '../utils/logger';

const log = createFileLogger('GLOBAL_OPEN_DIALOG_SHORTCUT', { enabled: false });

/**
 * Global shortcut: Cmd+O (Mac) / Ctrl+O (Windows/Linux)
 * Creates an OpenDialog entity and opens it in a new window
 * Follows pattern from GLOBAL_SHORTCUTS_GUIDE.md
 */
export const useGlobalOpenDialogShortcut = () => {
  useEffect(() => {
    log.log('🎯 [useGlobalOpenDialogShortcut] Hook mounted, registering Cmd+O...');
    log.log('[useGlobalOpenDialogShortcut] Hook mounted, registering Cmd+O...');
    
    // Register global shortcut (Cmd+O on Mac, Ctrl+O on Windows/Linux)
    globalShortcutsService.register({
      id: 'global_open_dialog',
      key: 'o',
      modifiers: {
        cmd: true   // Works as Cmd on Mac, Ctrl on Windows/Linux
      },
      description: 'Open entity picker',
      handler: () => {
        log.log('🚀 [useGlobalOpenDialogShortcut] Handler called! Creating OpenDialog...');
        log.log('[useGlobalOpenDialogShortcut] Creating OpenDialog via shortcut');
        
        // Get current space ID from URL
        const match = window.location.pathname.match(/\/spaces\/([^/]+)/);
        const spaceId = match ? match[1] : null;
        
        if (!spaceId) {
          log.warn('[useGlobalOpenDialogShortcut] No active space in URL, cannot create OpenDialog');
          return;
        }
        
        // Import dynamically to avoid circular dependencies
        import('../stores/commandRegistryStore').then(({ useCommandRegistryStore }) => {
          const { executeCommand } = useCommandRegistryStore.getState();
          
          executeCommand('open_dialog_create', {
            title: 'Open',
            spaceId,
            createWindow: true
          }).then(() => {
            log.log('[useGlobalOpenDialogShortcut] ✅ OpenDialog created');
            log.log('[useGlobalOpenDialogShortcut] ✅ OpenDialog created and opened');
          }).catch(error => {
            console.error('[useGlobalOpenDialogShortcut] ❌ Failed to create OpenDialog:', error);
            log.error('[useGlobalOpenDialogShortcut] Failed to create OpenDialog:', error);
          });
        });
      }
    });
    
    log.log('✅ [useGlobalOpenDialogShortcut] Shortcut registered successfully');
    log.log('[useGlobalOpenDialogShortcut] ✅ Shortcut registered successfully');
    
    return () => {
      log.log('[useGlobalOpenDialogShortcut] Unregistering shortcut');
      globalShortcutsService.unregister('global_open_dialog');
    };
  }, []); // ✅ Empty deps array - register once on mount
};

